<template>
  <div class="privacy-content">
    <h1>隐私政策</h1>
    <p>
      加加互动（厦门）体育产业有限公司开发了该免费的应用程序跳绳裁判助手。该服务由加加互动（厦门）体育产业有限公司提供，旨在协助跳绳裁判员们进行赛事的执裁及评分。
    </p>
    <p>
      我们对您使用跳绳裁判助手的隐私政策做出规定，并解释了我们如何收集、保护和披露您因使用我们的服务而产生的信息。
    </p>
    <p>
      如果您选择使用我们提供的服务，则表示您同意收集和使用与此政策相关的信息。我们收集的个人信息用于提供和改进服务。除非本隐私政策中另有说明，否则我们不会与任何人一起使用或分享您的信息。
    </p>
    <p>
      除非本隐私政策另有规定，否则本隐私政策中使用的术语与我们的条款和条件具有相同的含义，可在跳绳裁判助手中访问。
    </p>

    <h2>个人敏感信息收集与使用</h2>
    <p><strong>我们可能会处理您的以下个人敏感信息：</strong></p>
    <ul>
      <li><strong>身份证号：</strong>用于识别和认证裁判身份。</li>
      <li><strong>面部识别特征：</strong>如果您的裁判认证流程需要面部验证，我们将使用此信息进行识别。</li>
      <li><strong>联系电话：</strong>用于赛事通知和紧急联络。</li>
      <li><strong>裁判证编号：</strong>用于确认裁判资格。</li>
      <li><strong>未满14周岁未成年人的个人信息：</strong>如裁判为未成年人，我们将遵守法律规定对其信息进行特别保护。</li>
      <li>您可以自行在“我的”页面点击设置，点击”注销账户“提交账户注销申请，我们会根据具体您的情况在3~5个工作日内注销您需要注销的账号及信息。</li>
    </ul>
    <p style="color: red; font-weight: bold;">请注意，这些信息属于个人敏感信息，在未获得您的同意或法律要求的情况下，我们不会处理此类信息。</p>

    <h2>记录数据</h2>
    <p>
      当您使用我们的服务时，如果应用程序出现错误，我们会通过第三方数据统计在您的手机上收集数据和信息。该日志数据可能包含以下信息，例如：您的设备Internet协议（IP）地址，设备名称，操作系统版本，使用我们的服务时应用的配置，您使用该服务的时间和日期以及其他统计信息。
    </p>

    <h2>Cookies</h2>
    <p>
      Cookies是具有少量数据的文件，通常用作匿名唯一标识符。这些信息将从您访问的网站发送到浏览器，并存储在设备的内存中。
    </p>

    <h2>服务供应商</h2>
    <p>我们可能由于以下原因雇用第三方公司和个人：</p>
    <ul>
      <li>促进我们的服务质量；</li>
      <li>代表我们提供服务；</li>
      <li>提供与服务相关的服务；</li>
      <li>帮助我们分析如何使用我们的服务。</li>
    </ul>
    <p>
      我们想通知此服务的用户，这些第三方有权访问您的个人信息。原因是代表我们执行分配给他们的任务。但是，他们有义务不出于任何其他目的披露或使用该信息。
    </p>

    <h2>安全</h2>
    <p>
      我们很重视您对我们提供您的个人信息的信任，因此我们正在努力使用商业上可接受的方法来保护它。但是请记住，没有一种通过互联网传输的方法，或者说电子存储的方法是100%安全可靠的，我们不能保证它的绝对安全性。
    </p>

    <h2>到其他网站的链接</h2>
    <p>
      此服务可能包含指向其他网站的链接。如果您点击第三方链接，您将被引导到该网站。注意，这些外部站点不是由我们操作的。因此，我们强烈建议您查看这些网站的隐私策略。我们对任何第三方网站或服务的内容、隐私政策或做法没有控制权，也不承担任何责任。
    </p>

    <h2>儿童隐私</h2>
    <p>
      这些服务不面向13岁以下的青少年。我们不会有意收集13岁以下儿童的个人身份信息。如果我们发现13岁以下的儿童向我们提供了个人信息，我们会立即从我们的服务器中删除这些信息。如果您是父母或监护人，并且知道您的孩子向我们提供了个人信息，请与我们联系，以便我们能够采取必要的措施。
    </p>

    <h2>本隐私政策的变更</h2>
    <p>
      我们可能会不时更新我们的隐私政策。因此，建议您定期查看此页以了解更改。如有任何更改，我们会在本页公布新的隐私政策。该政策自2024-06-27起生效。
    </p>

    <h2>联系我们</h2>
    <p>
      如果您对我们的隐私政策有任何疑问或建议，请随时通过developadmin@ijustjump.com与我们联系。
    </p>
  </div>
</template>

<script>
export default {
  name: 'PrivacyView',
};
</script>

<style scoped>
.privacy-content {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.6;
  font-family: 'Arial', sans-serif;
  color: #333;
}

h1, h2 {
  font-size: 28px;
  font-weight: bold;
  margin-top: 20px;
}

h3 {
  font-size: 20px;
  font-weight: bold;
  margin-top: 20px;
}

p {
  font-size: 16px;
  margin-bottom: 15px;
}

ul {
  padding-left: 20px;
  list-style-type: disc;
}

li {
  margin-bottom: 10px;
}

p strong {
  font-size: 18px;
  color: #ff0000; /* 使用红色突出显示个人敏感信息 */
}
</style>